import axios from "../../utils/axios";
import React, { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getMe } from "../../data/me";
const AuthContext = createContext({});
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const [admin, setAdmin] = useState(false);
  const dispatch = useDispatch();
  const meStatus = useSelector((state) => state.me.status);
  const User = useSelector((state) => state.me.data);

  useEffect(() => {
    async function loadUserFromCookies() {
      const token = window.localStorage.getItem("token");
      if (token) {
        if (meStatus == "idle") {
          dispatch(getMe());
        } else if (meStatus == "succeeded") {
          console.log(User);

          if (
            window.location.pathname == "/categories" ||
            window.location.pathname == "/statistics" ||
            window.location.pathname == "/events" ||
            window.location.pathname == "/status" ||
            window.location.pathname == "/gallery" ||
            window.location.pathname == "/calendar"
          ) {
            if (!User) {
              navigate("/login");
            } else if (User.role == "user" && !User.is_active) {
              navigate("/not-activated");
            } else if (User.role == "user" && User.is_active) {
              navigate("/profile");
            } else if (User.role == "pre-admin" && !User.is_active) {
              navigate("/not-activated");
            } else if (User.role == "pre-admin" && User.is_active) {
              return;
            } else if (User.role == "admin") {
              setAdmin(true);
              return;
            }
          } else if (
            window.location.pathname != "/profile" &&
            window.location.pathname != "/awards" &&
            window.location.pathname != "/calendar" &&
            window.location.pathname != "/support"
          ) {
            if (!User) {
              navigate("/login");
            } else if (User.role == "user" && !User.is_active) {
              navigate("/not-activated");
            } else if (User.role == "user" && User.is_active) {
              navigate("/profile");
            } else if (User.role == "pre-admin" && User.is_active) {
              navigate("/profile");
            } else if (User.role == "admin") {
              setAdmin(true);
              return;
            }
          } else {
            if (!User) {
              console.log(User);
              navigate("/login");
            } else if (User.role == "user" && !User.is_active) {
              navigate("/not-activated");
            } else if (User.role == "user" && User.is_active) {
              return;
            } else if (User.role == "pre-admin" && !User.is_active) {
              navigate("/not-activated");
            } else if (User.role == "pre-admin" && User.is_active) {
              navigate("/profile");
              return;
            } else if (User.role == "admin") {
              setAdmin(true);
              return;
            }
          }
        } else {
          console.log(User);
          navigate("/login");
        }
      } else {
        navigate("/login");
      }
      console.log(meStatus);
    }
    loadUserFromCookies();
  }, [meStatus]);
  console.log(user);
  const login = async (email, password) => {
    const { data: token } = await axios.post("auth/login", { email, password });
    if (token) {
      console.log("Got token");
      window.localStorage.setItem("token", token, { expires: 60 });
      axios.defaults.headers.Authorization = `Bearer ${token.token}`;
      const { data: user } = await axios.get("users/me");
      setUser(user);
      console.log("Got user", user);
    }
  };

  const logout = (email, password) => {
    window.localStorage.removeItem("token");
    setUser(null);
    delete axios.defaults.headers.Authorization;
    window.location.pathname = "/login";
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated: !!user, user, login, loading, logout, admin }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export const ProtectRoute = ({ children }) => {
  const { loading } = useAuth();
  //   const router = useRouter();
  if (loading) {
    return <></>;
  }
  return children;
};

export const useAuth = () => useContext(AuthContext);
